import { SVGProps, useId } from "react";

export default function DrumrollReactionIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, color = "#757575", ...rest } = props;
  const id = useId();
  const clipId = `drumroll_reaction_${id}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M18.5588 7.17607L18.8824 6.67607C18.7059 6.55842 18.4706 6.44077 18.2353 6.35254L18 6.88195C18.1765 6.97019 18.3824 7.08783 18.5588 7.17607Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M14.0859 5.97007C15.4389 6.11713 16.5565 6.35242 17.4389 6.64654L17.6448 6.08772C16.733 5.76419 15.5565 5.52889 14.1742 5.38184L14.0859 5.97007Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M5.50092 6.02964L5.41268 5.44141C5.2068 5.47082 4.97151 5.50023 4.76562 5.52964L4.85386 6.11788C5.05974 6.08846 5.29504 6.05905 5.50092 6.02964Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M2.11811 6.85225C2.67693 6.61696 3.38281 6.41108 4.17693 6.26402L4.05928 5.67578C3.20634 5.85225 2.47105 6.05813 1.88281 6.32284L2.11811 6.85225Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M19 8.55854C19 7.26442 15.6765 6.49971 11.8824 6.29383L10.4118 4.82324L14.5 0.764419L14.0882 0.352654L10 4.41148L5.91177 0.323242L5.5 0.735007L9.58823 4.82324L8.11765 6.29383C4.35294 6.49971 1 7.26442 1 8.55854V17.3527C1 19.3527 8 19.6468 10 19.6468C12 19.6468 19 19.3232 19 17.3527V8.55854ZM4.79412 10.4703L3.44118 18.3821H3.41177L1.85294 9.61736C2.67647 10.0585 3.91176 10.3232 4.79412 10.4703ZM5.38235 10.5585C5.52941 10.5879 5.73529 10.6174 5.88235 10.6174L7.35294 18.9703C6.11765 18.8821 4.97059 18.735 4.02941 18.4997L5.38235 10.5585ZM6.5 10.7056C6.94118 10.735 7.35294 10.7938 7.79412 10.7938C8.23529 10.8232 8.67647 10.8527 9.08824 10.8527L7.82353 18.235L6.5 10.7056ZM13.5 10.7056L12.1765 18.235L10.9118 10.8527C11.7647 10.8232 12.6471 10.7938 13.5 10.7056ZM14.1176 10.6174C14.2941 10.5879 14.4412 10.5879 14.6176 10.5585L15.9706 18.4997C15.0294 18.7056 13.8824 18.8527 12.6471 18.9703L14.1176 10.6174ZM16.5588 18.3821L15.1765 10.4703C16.0882 10.3232 17.3235 10.0291 18.1176 9.61736L16.5588 18.3821ZM10 5.23501L11.0294 6.26442C10.3235 6.23501 9.70588 6.23501 8.97059 6.26442L10 5.23501ZM7.47059 6.94089L6.94118 7.4703C6.79412 7.38207 6.61765 7.35265 6.44118 7.35265C5.85294 7.35265 5.41177 7.82324 5.41177 8.38207C5.41177 8.9703 5.88235 9.41148 6.44118 9.41148C7.02941 9.41148 7.47059 8.94089 7.47059 8.38207C7.47059 8.2056 7.41177 8.02912 7.35294 7.88207L8.35294 6.88207C9.44118 6.82324 10.5294 6.82324 11.6176 6.88207L12.6176 7.88207C12.5294 8.02912 12.5 8.2056 12.5 8.38207C12.5 8.9703 12.9706 9.41148 13.5294 9.41148C14.0882 9.41148 14.5588 8.94089 14.5588 8.38207C14.5588 7.79383 14.0882 7.35265 13.5294 7.35265C13.3529 7.35265 13.1765 7.41148 13.0294 7.4703L12.5 6.94089C16.1471 7.2056 18.3824 7.99971 18.3824 8.55854C18.3824 9.99971 10.6765 10.3821 7.76471 10.2056C6.58824 10.1468 1.55882 9.61736 1.55882 8.55854C1.58824 7.9703 3.82353 7.2056 7.47059 6.94089ZM6.91177 8.38207C6.91177 8.61736 6.70588 8.82324 6.47059 8.82324C6.23529 8.82324 6.02941 8.61736 6.02941 8.38207C6.02941 8.14677 6.23529 7.94089 6.47059 7.94089C6.70588 7.94089 6.91177 8.11736 6.91177 8.38207ZM13.5294 7.91148C13.7647 7.91148 13.9706 8.11736 13.9706 8.35265C13.9706 8.58795 13.7647 8.79383 13.5294 8.79383C13.2941 8.79383 13.0882 8.58795 13.0882 8.35265C13.0882 8.11736 13.2941 7.91148 13.5294 7.91148ZM1.58824 17.3527V11.4115L2.79412 18.1762C1.91176 17.8527 1.58824 17.5585 1.58824 17.3527ZM8.26471 19.0291L9.67647 10.8527H10.2941L11.7059 19.0291C11.1765 19.0585 10.5882 19.0879 10 19.0879C9.41177 19.0879 8.82353 19.0585 8.26471 19.0291ZM17.2059 18.1762L18.4118 11.4115V17.3527C18.4118 17.5585 18.0882 17.8527 17.2059 18.1762Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M3.5625 1.26465H4.15074V2.02935H3.5625V1.26465Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M3.5625 2.82324H4.15074V3.58795H3.5625V2.82324Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M2.70312 2.11719H3.46783V2.70542H2.70312V2.11719Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M4.26562 2.11719H5.03033V2.70542H4.26562V2.11719Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M16.1797 1.44141H16.7679V2.20611H16.1797V1.44141Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M16.1797 3H16.7679V3.76471H16.1797V3Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M15.3203 2.29395H16.085V2.88218H15.3203V2.29395Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
        <path
          d="M16.8828 2.29395H17.6475V2.88218H16.8828V2.29395Z"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
